var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskWait({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 8,
    fill: "white",
    stroke: "#81889A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2139 9.80559C18.6482 9.80352 18.9999 9.41145 18.9999 8.92791V7.87768C18.9999 7.39413 18.6445 7 18.2084 7H9.79144C9.35545 7 9 7.39413 9 7.87768V8.93006C9 9.41155 9.35173 9.80362 9.78596 9.80774C9.90692 11.376 10.7094 12.7494 11.926 13.501C10.7094 14.2527 9.90691 15.6281 9.78596 17.1943C9.35173 17.1983 9 17.5905 9 18.072V19.1223C9 19.6058 9.35545 20 9.79153 20H18.2085C18.6446 20 19 19.6058 19 19.1223L18.9999 18.072C18.9999 17.5905 18.6482 17.1984 18.2139 17.1943C18.093 15.626 17.2905 14.2526 16.0739 13.501C17.2905 12.7473 18.093 11.374 18.2139 9.80559ZM9.73267 8.92997V7.87768C9.73267 7.84111 9.75831 7.81268 9.79129 7.81268H18.2082C18.2412 7.81268 18.2668 7.84111 18.2668 7.87768V8.93006C18.2668 8.96663 18.2412 8.99506 18.2082 8.99506L9.79129 8.99497C9.75831 8.99497 9.73267 8.96458 9.73267 8.92997ZM18.2671 18.0721V19.1224C18.2671 19.159 18.2414 19.1874 18.2084 19.1874H9.7913C9.75832 19.1874 9.73267 19.159 9.73267 19.1224V18.0721C9.73267 18.0355 9.75832 18.0071 9.7913 18.0071H18.2082C18.2413 18.0071 18.2671 18.0375 18.2671 18.0721ZM15.0369 13.1129C14.883 13.1658 14.7785 13.3221 14.7785 13.501C14.7785 13.6797 14.883 13.8362 15.0369 13.889C16.3945 14.3542 17.3417 15.6545 17.4847 17.1944H10.5133C10.6562 15.6545 11.6034 14.3542 12.9628 13.889C13.1168 13.8362 13.2212 13.6798 13.2212 13.501C13.2212 13.3222 13.1168 13.1658 12.9628 13.1129C11.6052 12.6477 10.658 11.3475 10.515 9.8075H17.4865C17.3417 11.3454 16.3946 12.6455 15.0369 13.1129Z",
    fill: "#81889A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskWait);
export default __webpack_public_path__ + "static/media/task-wait.1df9d49c5d26ac9a50ceb48786db8450.svg";
export { ForwardRef as ReactComponent };